 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","default~pages-home-home-module~pages-my-account-my-account-module":"default~pages-home-home-module~pages-my-account-my-account-module","pages-home-home-module":"pages-home-home-module","pages-my-account-my-account-module":"pages-my-account-my-account-module","pages-about-us-about-us-module":"pages-about-us-about-us-module","pages-book-of-rules-book-of-rules-module":"pages-book-of-rules-book-of-rules-module","pages-casino-login-casino-login-module":"pages-casino-login-casino-login-module","pages-confirm-registration-confirm-registration-module":"pages-confirm-registration-confirm-registration-module","pages-news-news-module":"pages-news-news-module","pages-racing-paper-racing-paper-module":"pages-racing-paper-racing-paper-module","pages-results-results-module":"pages-results-results-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","tabs-myAccount-my-profile-my-profile-module":"tabs-myAccount-my-profile-my-profile-module","tabs-myAccount-my-slips-my-slips-module":"tabs-myAccount-my-slips-my-slips-module","tabs-myAccount-transaction-transaction-module":"tabs-myAccount-transaction-transaction-module"}[chunkId]||chunkId) + "-es2015." + {"0":"e8c3bf09343f36928bde","1":"c78a2a7981c07bfbba47","2":"be8c978261c05db54f1e","3":"e91214170051dcf4f1f7","4":"0448f70b8dbf51e830a9","5":"1b52e1071d8afde31995","6":"7a044842bdb80b3ca647","7":"863a278c514b4d9a9eec","8":"9627ca53a6b3719f07e1","9":"e83dac341790cc756f7d","10":"c91c350bf9dafc05ce65","11":"81b5587f050dfa8a0cff","12":"5a184cf28b037ea59a81","13":"4033d7646ce95279b09c","14":"d48d23b73290317c4cee","15":"6cde147eb621b1cffeb5","16":"76f1e63272f4b013a87e","17":"70f1eadd1dee30cb8fac","18":"005f0ca28e595607c9c5","19":"8780a804d7bf66836345","20":"12c480b6dc0b06b7861f","21":"9d514bd42329fdd0a5f3","22":"e67f71a7766b8b6725bb","23":"78bb7fcdece52c651647","24":"5fc909fa29f2cc132e80","25":"7b0379aa4be16b30d463","26":"15caf985230003bbeabb","27":"3ee53a223b71e54239a7","28":"a45ac3329d4e44c7691f","29":"4bc3236bae89cec9b3f4","30":"87254d35b6906d6c5c96","31":"bb35ed94d6657e6fe3e3","32":"570919580b6d227233e5","33":"b69fc3dd35349e787c6d","34":"ac9b0f15ca0e4544f739","35":"af9210b079ad2e0c785f","36":"a1164ec9500b42eb3f1d","37":"81a1f8d115c732f67c0b","38":"22f819de7936802989c2","39":"7ef4c4c01faba34647bb","40":"446e1c54ec7ac15df8a2","41":"16beeb4297517eedaeb6","42":"a60487f0c1ba4b2251d3","common":"e076c91a158b4dd10490","default~pages-home-home-module~pages-my-account-my-account-module":"5429d365344677757767","pages-home-home-module":"f2a9cc9d41c0cde7e9ee","pages-my-account-my-account-module":"ad83dac0c0ad366cbd58","pages-about-us-about-us-module":"8d8c7ebe3bc760a20815","pages-book-of-rules-book-of-rules-module":"26e556e01477a09111ef","pages-casino-login-casino-login-module":"4f5295ea23f1132dbc02","pages-confirm-registration-confirm-registration-module":"a3e02a0e5b39ee319ed2","pages-news-news-module":"7e11e23644d5a7b8e44d","pages-racing-paper-racing-paper-module":"22ae20a70fd6f908b129","pages-results-results-module":"e46da2fa0a4e25955bb5","polyfills-core-js":"ee25f16597f4b004482f","polyfills-css-shim":"1caf49be2ef5bfadf1e7","polyfills-dom":"6e730f03adc318fe7ad7","shadow-css-a3f00b33-js":"af3ced5da33f30b399a6","swiper-bundle-6c5e7804-js":"bf31b0bc7245a19488dd","focus-visible-f4ad4f1a-js":"4bdcd19dfaa32a13e964","input-shims-ce03ee9f-js":"c3ee1e4e3b5495b2f9d5","keyboard-5742b5da-js":"53097d11acdc903964ad","status-tap-9cb487b1-js":"fd9ecc3f93adecf9d7ce","swipe-back-1bbd08e0-js":"1106ca53bcf4e1c7617a","tap-click-7ddcdebb-js":"5ae5f578800f019e560b","tabs-myAccount-my-profile-my-profile-module":"9c37509690384f0c2c59","tabs-myAccount-my-slips-my-slips-module":"57fa6d75a415fc2ea6d0","tabs-myAccount-transaction-transaction-module":"a7c0b18ada2c4b08dc32"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
